var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyAccountIconInactiveNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91797 2.5H12.0846C12.4162 2.5 12.7341 2.6317 12.9685 2.86612C13.2029 3.10054 13.3346 3.41848 13.3346 3.75C13.3346 4.52355 13.0273 5.26541 12.4804 5.81239C11.9334 6.35938 11.1915 6.66667 10.418 6.66667H9.58463C8.81109 6.66667 8.06922 6.35938 7.52224 5.81239C6.97526 5.26541 6.66797 4.52355 6.66797 3.75C6.66797 3.41848 6.79966 3.10054 7.03409 2.86612C7.26851 2.6317 7.58645 2.5 7.91797 2.5Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 14.1719V13.3385C3.33203 11.5704 4.03441 9.87474 5.28465 8.6245C6.53489 7.37425 8.23059 6.67188 9.9987 6.67188C11.7668 6.67188 13.4625 7.37425 14.7127 8.6245C15.963 9.87474 16.6654 11.5704 16.6654 13.3385V14.1719C16.6654 15.0559 16.3142 15.9038 15.6891 16.5289C15.0639 17.154 14.2161 17.5052 13.332 17.5052H6.66536C5.78131 17.5052 4.93346 17.154 4.30834 16.5289C3.68322 15.9038 3.33203 15.0559 3.33203 14.1719Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.625H9.6875C9.43886 10.625 9.2004 10.7238 9.02459 10.8996C8.84877 11.0754 8.75 11.3139 8.75 11.5625C8.75 11.8111 8.84877 12.0496 9.02459 12.2254C9.2004 12.4012 9.43886 12.5 9.6875 12.5H10.3125C10.5611 12.5 10.7996 12.5988 10.9754 12.7746C11.1512 12.9504 11.25 13.1889 11.25 13.4375C11.25 13.6861 11.1512 13.9246 10.9754 14.1004C10.7996 14.2762 10.5611 14.375 10.3125 14.375H8.75",
    stroke: "#FAFAFA",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.375V15M10 10V10.625",
    stroke: "#FAFAFA",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountIconInactiveNew);
export default __webpack_public_path__ + "static/media/myAccountIconInactiveNew.5e2da6ae5247fcc8cff5fa6bb0e719b7.svg";
export { ForwardRef as ReactComponent };